export const parseGenerator = (raw: string) => {
  const parts = raw.split('|');
  const generatorId = parts[0];

  return generatorId;
};

export const parsePosition = (raw: number[]) => {
  let [x, y, z] = raw;

  x = x - 2.5;
  z = z - 2.5;

  return [x, y, z] as [number, number, number];
};
